<template>
    <div>
        <div v-if="coupons && coupons.length" class="coupon-page">
            <div class="coupon-item" v-for="item  in coupons" :key="item.Id" @click="item_onclick">
                <div class="item-body">
                    <div class="left">
                        <h2>￥{{ item.MaxAmount }}</h2>
                        <span v-if="item.MinOrderAmount">满{{ item.MinOrderAmount }}元可用</span>
                        <span v-else>任意金额可用</span>
                    </div>
                    <div class="right">
                        <h2>{{ item.Name }}</h2>
                        <span>{{ getDateText(item.CreatedAt) }} - {{ getDateText(item.Expired) }} </span>
                    </div>
                    <div class="use">
                        <router-link to="/order">立即使用</router-link>
                    </div>
                </div>
                <div class="text">{{ item.Description }} </div>
            </div>
        </div>
        <div v-else> 暂无优惠券！ </div>
    </div>
</template>
 
<script>
import CouponApi from "~/api/coupon"
import { Dialog, Toast } from "vant"
export default {
    name: "couponView",
    components: {

    },
    data() {
        return {
            coupons: []
        };
    },

    methods: {
        async getList(pagination, searchData) {

        },
        onData(e) {
            this.coupons = e
        },
        getDateText(dStr) {
            var d = new Date(dStr);
            return d.toLocaleDateString();
        },
        item_onclick() {
            //this.$router.push("/")
        }

    },
    created() {
        CouponApi.takeList({}).then(this.onData)
    },
    beforeRouteEnter(to, from, nextFun) {
        if (from.name == "register") {
            Dialog.alert({
                message:
                    "建议您在电脑上操作以获得更好体验。\n电脑端网址：znlscm.com 。\n如有疑问请致电：0755-82798001，谢谢~"
            }).then(() => {
                navigator.clipboard.writeText("https://znlscm.com/").then(() => {
                    Toast.success("网址已经复制");
                }); ``
            });
        }
        nextFun();
    }

};
</script>
<style lang="scss" scoped>
.coupon-page {
    .coupon-item {
        border: 0.01rem solid #F53F3F;
        border-top: 0.04rem solid #F53F3F;

        border-radius: 0.08rem;
        margin: 0 0.5em;

        &+.coupon-item {
            margin-top: 1em;
        }

        .item-body {
            display: flex;
            flex-direction: row;
            padding: 0 0.05rem;
            align-items: center;
        }

        .left {
            width: 1rem;
            text-align: center;
            padding: 0.5em 0;
            color: #666;

            h2 {
                font-size: 0.24rem;
                color: #F53F3F;
            }
        }

        .use {
            width: 0.33rem;
            font-size: 0.14rem;
            text-align: center;
            margin-right: 0.15rem;
            color: dodgerblue;
        }

        .text {
            color: #999;
            border-top: #666 dotted 0.01rem;
            padding: 1em 1em;
            margin: 0 0.2rem;
        }

        .right {
            color: #666;
            padding: 0.5em 0;
            flex: auto;

            h2 {
                font-size: 0.14rem;
                line-height: 2em;
                color: #666;
            }
        }
    }
}
</style>
